var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie_"},[_c('apexchart',{attrs:{"type":"pie","width":_vm.width,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }